import { useKeyboard } from '@react-native-community/hooks'
import { useToast as useToastNative } from 'native-base'
import { useCallback, useRef } from 'react'

import { useDeviceInfo } from '../useDeviceInfo'
import { Toast, ToastType } from './Toast'
export const useToast = () => {
  const { keyboardShown } = useKeyboard()
  const { isWeb } = useDeviceInfo()
  const toast = useToastNative()
  const toastIdRef = useRef()

  const closeToast = useCallback(() => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current)
    }
  }, [toast])

  const showToast = useCallback(
    (props: Omit<ToastType, 'onPress'>) => {
      if (!toast.isActive(toastIdRef.current)) {
        toastIdRef.current = toast.show({
          render: () => <Toast onPress={closeToast} {...props} />,
          placement: keyboardShown || isWeb ? 'top' : 'bottom',
          ...props,
        })
      }
    },
    [closeToast, isWeb, keyboardShown, toast]
  )

  return {
    closeToast,
    showToast,
  }
}
